/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

class ApiClient {
	private client: AxiosInstance;
	private token: string | null = null;

	constructor() {
		this.client = axios.create({
			baseURL: process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000",
			headers: {
				"Content-Type": "application/json",
			},
		});

		// Request interceptor to add auth token
		this.client.interceptors.request.use(
			(config) => {
				if (this.token) {
					config.headers.Authorization = `Bearer ${this.token}`;
				}
				return config;
			},
			(error) => Promise.reject(error)
		);

		// Response interceptor for error handling
		this.client.interceptors.response.use(
			(response) => response,
			(error) => {
				if (error.response?.status === 401) {
					this.clearToken();
					if (typeof window !== "undefined") {
						// window.location.href = "/admin/login";
					}
				}
				return Promise.reject(error);
			}
		);

		// Load token from localStorage on client side
		if (typeof window !== "undefined") {
			this.token = localStorage.getItem("admin_token");
		}
	}

	setToken(token: string) {
		this.token = token;
		if (typeof window !== "undefined") {
			localStorage.setItem("admin_token", token);
		}
	}

	clearToken() {
		this.token = null;
		if (typeof window !== "undefined") {
			localStorage.removeItem("admin_token");
		}
	}

	getToken(): string | null {
		return this.token;
	}

	async get<T>(url: string, config?: AxiosRequestConfig) {
		const response = await this.client.get<T>(url, config);
		return response.data;
	}

	async post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
		const response = await this.client.post<T>(url, data, config);
		return response.data;
	}

	async put<T>(url: string, data?: any, config?: AxiosRequestConfig) {
		const response = await this.client.put<T>(url, data, config);
		return response.data;
	}

	async delete<T>(url: string, config?: AxiosRequestConfig) {
		const response = await this.client.delete<T>(url, config);
		return response.data;
	}

	async patch<T>(url: string, data?: any, config?: AxiosRequestConfig) {
		const response = await this.client.patch<T>(url, data, config);
		return response.data;
	}
}

export const apiClient = new ApiClient();
